import { request } from '../request';

export const editPreboarding = async (data: FormData) => {
  const response = await request.patch(`v1/preboarding/`, data);
  return response.data;
};

export const loadPreboardingTeams = async () => {
  const response = await request.get('v1/preboarding/teams/');
  return response.data;
};

export type PreboardingTeams = {
  teams: string[];
};

export const createPreboardingTeams = async (data: PreboardingTeams) => {
  const response = await request.post('v1/preboarding/teams/', data);
  return response.data;
};
